<template>
	<div class="vlog-search">

		<div class="py-4 search-bar">
			<form role="form" class="relative flex z-50  bg-gray-100  rounded-full">
				
				<input
					v-model="searchTerm"
					type="search"
					id="search-videos"
					placeholder="搜索视频"
					class="text-sm rounded-full flex-1  bg-gray-100  px-6 py-2 text-gray-700 focus:outline-none"
				/>

				<button
					type="submit"
					@click.prevent="handleSearch"
					class="text-sm bg-indigo-500 text-white rounded-full font-semibold px-4 py-1.5 m-1 focus:outline-none"
				>
					搜索
				</button>
			</form>
		</div>

		<!-- https://flowbite.com/docs/forms/search-input/
		<div class="searchbar-container p-3">
			<form>
				<label
					for="default-search"
					class="mb-2 text-sm font-medium text-gray-900 sr-only"
					>Search</label
				>
				<div class="relative">
					<div
						class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none"
					>
						<svg
							aria-hidden="true"
							class="w-5 h-5 text-gray-500 dark:text-gray-400"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
							></path>
						</svg>
					</div>
					<input
						v-model="searchTerm"
						type="search"
						id="default-search"
						class="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50"
						placeholder="搜索所有视频内容"
					/>
					<button
						type="submit"
						@click.prevent="handleSearch"
						class="text-white absolute right-2.5 bottom-2.5 bg-blue-700 font-medium rounded-lg text-sm px-4 py-2 "
					>
						搜索
					</button>
				</div>
			</form>
		</div> -->

		<!-- 其他筛选条件待定 -->
		<div class="list-content-container" v-if="shouldShowResults">
			<div class="results-title" v-if="this.title?.trim().length > 0">
				<h1>{{ title }}</h1>
			</div>
			<vlog-content-list :keywords="resultKeywords" :showDesc="true" emptyIndicatorText="没有找到搜索结果"> </vlog-content-list>
		</div>
	</div>
</template>

<script>
import VlogContentList from "@/components/vlog/contentList/VlogContentList.vue";
import { useHead, useSeoMeta } from "@vueuse/head";

// 1. 接收链接的参数，应用到搜索框，同时reset内容列表
// 2. 搜索框手动更新后，reset内容列表，并更新链接
// 0. 每次更新keywords以后，整个内容列表需要重新设置。一种土办法是先showResults = false来清理，nextTick里重新show

export default {
	name: "VlogSearchResults",
	components: {
		VlogContentList,
	},
	data() {
		return {
			resultKeywords: "",
			showResults: false,
			searchTerm: "",
			title: "",
		};
	},
	computed: {
		shouldShowResults() {
			return this.showResults && this.resultKeywords?.trim().length > 0;
		},
		indicatorMessage() {
			return "请输入搜索关键词";
		},
		normalizedSearchTerm() {
			var trimmed = this.searchTerm?.trim();
			if (trimmed?.length == 0) {
				return "";
			}
			return trimmed;
		},
	},
	watch: {
		// searchTerm(newVal, oldVal) {
		// 	oldVal;
		// 	// console.log(newVal);
		// },
		// keywords(newVal, oldVal) {
		// 	oldVal;
		// 	console.log(newVal);
		// 	// reload content list
		// 	this.updateResults();
		// },
	},
	methods: {
		updateMeta() {
			// console.log(this.resultKeywords);
			var title;
			// 1. 有关键字，显示：关于"关键字"的视频
			// 2. 没有关键字，显示: 搜索视频
			const key = this.resultKeywords?.trim();
			if (key?.length > 0) {
				title = "关于\"" + key + "\"的视频";
				this.title = title;
			} else {
				title = "搜索视频";
				this.title = "";
			}

			const websiteBasicInfo = this.$store.state.websiteBasicInfo;

			var shareAbstract = "";
			if	(websiteBasicInfo) {
				shareAbstract = websiteBasicInfo.vlogDisplayTitle + "的视频内容";
			}
			const siteTitle = websiteBasicInfo?.vlogDisplayTitle;
			if (siteTitle) {
				title = title + " - " + siteTitle;
			}
			useHead({
				title: title,
				meta: [
					{
						name: "title",
						content: title,
					},
					{
						name: "description",
						content: websiteBasicInfo.description,
					},
					{
						name: "keywords",
						content: websiteBasicInfo.keywords,
					},
				],
			});
			useSeoMeta({
				description: shareAbstract,
				ogDescription: shareAbstract,
				ogTitle: title,
				ogImage: websiteBasicInfo.logoUrl,
			});

			this.shareInfo = {
					description: shareAbstract,
					title: title,
					image: websiteBasicInfo.logoUrl,
					url: document.location.href,
			}
				
			this.$emitter.emit("didUpdateHeadMeta", this.shareInfo);


			
		},
		handleSearch() {
			// console.log("handle search: " + this.normalizedSearchTerm);

			if (this.resultKeywords != this.normalizedSearchTerm) {
				// 2. update results list
				this.updateResults(this.normalizedSearchTerm);
				var query = Object.assign({}, this.$route.query);
				query.keywords = this.normalizedSearchTerm;
				// 3. update url.
				this.$router.replace({ path: this.$route.path, query });
			} else {
				// console.log("not updated ");
			}
		},
		updateResults(keywords) {
			const that = this;
			this.showResults = false;
			this.resultKeywords = keywords;
			this.$nextTick(function() {
				that.showResults = true;
			});

			this.updateMeta();
		},
	},
	mounted() {
		this.searchTerm = this.$route.query?.keywords?.trim();
		this.updateResults(this.normalizedSearchTerm);
	},
};
</script>
<style scoped>
.vlog-search {
	padding: 0 16px;
}
.results-title {
	text-align: center;
	font-size: 15px;
	font-weight: normal;
	color: #555;
	margin-bottom: 16px;
}

</style>
